import Vue from "vue";
import Router from "vue-router";

import auth from "@/middleware/auth";
import admin from "@/middleware/admin";
import streamer from "@/middleware/streamer";
import editor from "@/middleware/editor";

import DashboardLayout from "@/layouts/DashboardLayout";
import Login from "@/views/Login";
import ForgetPassword from "@/views/ForgetPassword";
import ResetPassword from "@/views/ResetPassword";
import ChangePassword from "@/views/ChangePassword";
import Dashboard from "@/views/Dashboard";
import Schedule from "@/views/Schedule";
import CreateUpdateSchedule from "@/views/CreateUpdateSchedule";
import PushNotification from "@/views/Notification/PushNotification";
import Notification from "@/views/Notification/Notification";
import LiveStream from "@/views/LiveStream";
import Club from "@/views/Club";
import CreateLiveStream from "@/views/CreateLiveStream";
import LiveStreamDetail from "@/views/LiveStreamDetail";
import NewsFeed from "@/views/NewsFeed/NewsFeed";
import CreatePost from "@/views/NewsFeed/CreatePost";
import PostDetail from "@/views/NewsFeed/PostDetail";
import CreateUser from "@/views/UserManagement/CreateUser";
import EditStreamer from "@/views/UserManagement/EditStreamer";
import EditUser from "@/views/UserManagement/EditUser";
import UserManagement from "@/views/UserManagement";
import Profile from "@/views/Profile";
import Configuration from "@/views/Configuration/Configuration";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/forget_password",
      name: "forget_password",
      component: ForgetPassword
    },
    {
      path: "/reset_password/:code",
      name: "reset_password",
      component: ResetPassword
    },
    {
      path: "/",
      redirect: "dashboard",
      component: DashboardLayout,

      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          component: Dashboard,
          beforeEnter: (to, from, next) => {
            auth(to, from, next);
          }
        },
        {
          path: "/schedule",
          name: "schedule",
          component: Schedule,
          beforeEnter: (to, from, next) => {
            streamer(to, from, next);
          }
        },
        {
          path: "/create_schedule",
          name: "create_schedule",
          component: CreateUpdateSchedule,
          beforeEnter: (to, from, next) => {
            streamer(to, from, next);
          }
        },
        {
          path: "/schedule/:id",
          name: "schedule_detail",
          component: CreateUpdateSchedule,
          beforeEnter: (to, from, next) => {
            streamer(to, from, next);
          },
          props: true
        },
        {
          path: "/notification",
          name: "notification",
          component: Notification,
          beforeEnter: (to, from, next) => {
            admin(to, from, next);
          }
        },
        {
          path: "/push_notification",
          name: "push_notification",
          component: PushNotification,
          beforeEnter: (to, from, next) => {
            admin(to, from, next);
          }
        },
        {
          path: "/live_stream",
          name: "live_stream",
          component: LiveStream,
          beforeEnter: (to, from, next) => {
            auth(to, from, next);
          }
        },
        {
          path: "/club",
          name: "Club",
          component: Club,
          beforeEnter: (to, from, next) => {
            admin(to, from, next);
          }
        },
        {
          path: "/create_live_stream",
          name: "create_live_stream",
          component: CreateLiveStream,
          beforeEnter: (to, from, next) => {
            streamer(to, from, next);
          }
        },
        {
          path: "/live_stream/:id",
          name: "live_stream_detail",
          component: LiveStreamDetail,
          beforeEnter: (to, from, next) => {
            auth(to, from, next);
          },
          props: true
        },
        {
          path: "/newsfeed",
          name: "newsfeed",
          component: NewsFeed,
          beforeEnter: (to, from, next) => {
            editor(to, from, next);
          }
        },
        {
          path: "/create_post",
          name: "create_post",
          component: CreatePost,
          beforeEnter: (to, from, next) => {
            editor(to, from, next);
          }
        },
        {
          path: "/newsfeed/:id",
          name: "post_detail",
          component: PostDetail,
          beforeEnter: (to, from, next) => {
            editor(to, from, next);
          },
          props: true
        },
        {
          path: "/create_user",
          name: "create_user",
          component: CreateUser,
          beforeEnter: (to, from, next) => {
            admin(to, from, next);
          }
        },
        {
          path: "/user_management",
          name: "user_management",
          component: UserManagement,
          beforeEnter: (to, from, next) => {
            auth(to, from, next);
          }
        },
        {
          path: "/configuration",
          name: "configuration",
          component: Configuration,
          beforeEnter: (to, from, next) => {
            admin(to, from, next);
          }
        },
        {
          path: "/streamer/:id",
          name: "edit_streamer",
          component: EditStreamer,
          beforeEnter: (to, from, next) => {
            admin(to, from, next);
          },
          props: true
        },
        {
          path: "/user/:id",
          name: "edit_user",
          component: EditUser,
          beforeEnter: (to, from, next) => {
            admin(to, from, next);
          },
          props: true
        },
        {
          path: "/profile",
          name: "profile",
          component: Profile,
          beforeEnter: (to, from, next) => {
            auth(to, from, next);
          }
        },
        {
          path: "/change_password",
          name: "change_password",
          component: ChangePassword,
          beforeEnter: (to, from, next) => {
            auth(to, from, next);
          }
        }
      ]
    }
  ]
});
